<div class="fab-container">
    <div class="options-container" *ngIf="isOpen" @listAnimation>
        <div class="option" *ngFor="let option of options">
            <button mat-button (click)="optionClicked(option)">
                <mat-icon>{{option.icon}}</mat-icon> {{option.text}}
            </button>
        </div>
    </div>
    <button mat-fab (click)="toggleOptions()" color="primary">
        <mat-icon [@spin]="isOpen ? 'opened' : 'closed'">{{isOpen ? openIcon : closeIcon}}</mat-icon>
    </button>
</div>